export default {"featuredMenu":"UpMli","featuredItem":"XO1oH","featuredIcon":"R2iOg"};